import { useState } from 'preact/hooks';
import { Wordmark } from '../components/Wordmark';
import { useT } from '../../i18n';
import { getDeviceId } from '../../utils/access';
import { adoptAccount, type AccountPayload } from '../../utils/account';

/**
 * Link — opened on the PHONE from the QR shown in the Tesla (#link/<code>).
 * Email → code → the Tesla that showed the QR is signed in (and this phone too).
 */
export function Link({ code: linkCode }: { code: string }) {
  const t = useT();
  const [step, setStep] = useState<'email' | 'code' | 'done'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const sendOtp = async (e: Event) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const r = await fetch('/api/auth/otp', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email }) });
      if (!r.ok) throw new Error('otp');
      setStep('code');
    } catch { setError(t('errSendCode')); }
    setBusy(false);
  };
  const verify = async (e: Event) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const r = await fetch('/api/auth/verify', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email, code, deviceId: getDeviceId(), linkCode }) });
      if (!r.ok) throw new Error('bad code');
      const j = (await r.json()) as AccountPayload;
      await adoptAccount({ ...j, email });
      setStep('done');
    } catch { setError(t('errBadCode')); }
    setBusy(false);
  };

  return (
    <main class="link">
      <div class="link__brand"><img class="brandmark brandmark--h" src="/logo.svg?v=1" alt="" /><Wordmark class="link__wordmark" /></div>
      <div class="link__card">
        {step === 'done' ? (
          <>
            <div class="link__ok">{t('linkDone')}</div>
            <p>{t('linkDoneBody', { email })}</p>
          </>
        ) : (
          <>
            <div class="link__title">{t('linkTitle')}</div>
            {step === 'email' && (
              <form class="acct__form" onSubmit={sendOtp}>
                <p class="acct__hint">{t('linkHint')}</p>
                <input class="acct__input" type="email" inputMode="email" autocomplete="email" placeholder="you@email.com" value={email} onInput={(e) => setEmail((e.currentTarget as HTMLInputElement).value)} autoFocus />
                <button class="acct__btn" disabled={busy || !email}>{busy ? t('sending') : t('continueBtn')}</button>
              </form>
            )}
            {step === 'code' && (
              <form class="acct__form" onSubmit={verify}>
                <p class="acct__hint">{t('weEmailed', { email })}</p>
                <input class="acct__input acct__input--code" inputMode="numeric" autocomplete="one-time-code" placeholder="123456" maxLength={6} value={code} onInput={(e) => setCode((e.currentTarget as HTMLInputElement).value)} autoFocus />
                <button class="acct__btn" disabled={busy || code.length < 4}>{busy ? t('checking') : t('signInBtn')}</button>
                <button type="button" class="acct__link" onClick={() => { setStep('email'); setCode(''); }}>{t('changeEmail')}</button>
              </form>
            )}
            {error && <p class="acct__err">{error}</p>}
          </>
        )}
      </div>
    </main>
  );
}
